import reduceReducers from 'reduce-reducers'
import { makeApiTypes } from 'sidecar-utility-library'

import Attachments from './Attachments'
import Poptart from './Poptart'
import Requests from './Requests'
import Unresolved from './Unresolved'

// Exporting all actions
export * from './Attachments'
export * from './Poptart'
export * from './Requests'
export * from './Unresolved'

export const types = {
  ...makeApiTypes('FETCH_SINGLE_COMMS_MESSAGE', 'memberCommunication'),
  ...makeApiTypes('FETCH_MEMBER_COMMS_MESSAGES', 'memberCommunication'),
  ...makeApiTypes('FETCH_UNRESOLVED_MESSAGES', 'memberCommunication'),
  ...makeApiTypes('POST_REQUEST_COMMENT', 'memberCommunication'),
  CLEAR_MEMBER_COMMS_MESSAGES:
    'memberCommunication/CLEAR_MEMBER_COMMS_MESSAGES',
  CLEAR_NEW_MESSAGE: 'memberCommunication/CLEAR_NEW_MESSAGE',
  CLEAR_UNRESOLVED_MESSAGES: 'memberCommunication/CLEAR_UNRESOLVED_MESSAGES',
  SET_ACTIVE_MESSAGE: 'memberCommunication/SET_ACTIVE_MESSAGE',
  SET_BODY_CONTENT: 'memberCommunication/SET_BODY_CONTENT',
  SET_POPTART_HISTORY: 'memberCommunication/SET_POPTART_HISTORY',
  PREV_POPTART_HISTORY: 'memberCommunication/PREV_POPTART_HISTORY', // Attachment thumbnails
  CLEAR_POPTART_HISTORY: 'memberCommunication/CLEAR_POPTART_HISTORY',
  ...makeApiTypes('FETCH_ATTACHMENT_THUMBNAIL', 'memberCommunication'),
  CLEAR_ATTACHMENT_THUMBNAILS:
    'memberCommunication/CLEAR_ATTACHMENT_THUMBNAILS',
  // Create request
  ...makeApiTypes('POST_MESSAGE', 'memberCommunication'),
  // Request title
  CLEAR_REQUEST_TYPE: 'memberCommunication/CLEAR_REQUEST_TYPE',
  SET_REQUEST_TYPE: 'memberCommunication/SET_REQUEST_TYPE',
  // "A ticket was just filed; the list you can fetch right now is behind reality."
  // Set when Ash hands off to the inbox, cleared by the re-fetch that follows.
  AWAIT_NEW_TICKET: 'memberCommunication/AWAIT_NEW_TICKET',
  // Download attachment
  ...makeApiTypes('DOWNLOAD_ATTACHMENT', 'memberCommunication'),
  SET_SELECTED_SPECIALTY: 'memberCommunication/SET_SELECTED_SPECIALTY',
  // See `setAshSessionId`.
  SET_ASH_SESSION_ID: 'memberCommunication/SET_ASH_SESSION_ID',
}

export const initialState = {
  attachmentError: {
    error: null,
  },
  attachmentThumbnails: {
    busy: false,
    error: null,
    entities: {},
  },
  newRequest: {
    busy: false,
    error: null,
    entity: {},
  },
  poptart: {
    bodyContent: null,
  },
  requestFlows: {
    history: [],
  },
  requests: {
    busy: false,
    error: null,
    activeRequest: {},
    entities: [],
    keyMap: {},
    expenseMap: {},
    // True between "Ash filed a ticket and sent the member here" and the re-fetch
    // that can actually see it. The list is knowably behind reality for that
    // moment, so the inbox shows its loading state instead of a list it would have
    // to correct a second later. See `awaitNewTicket` in `Requests.js`.
    awaitingNewTicket: false,
  },
  requestType: {
    entity: {
      title: '',
      id: '',
      fields: [],
    },
  },
  selectedSpecialty: {
    entity: '',
  },
  // Set on arrival from an Ash deep link, cleared once the ticket is filed.
  // '' means "not from Ash" — see `setAshSessionId`.
  ashSessionId: {
    entity: '',
  },
  unresolved: {
    busy: false,
    error: null,
    // TODO: once the endpoint is updated to handle request from the member app,
    // this should be changed to an empty object
    entity: { unresolved: null },
  },
  attachment: {
    busy: false,
    error: null,
  },
}

export default reduceReducers(
  Attachments,
  Poptart,
  Requests,
  Unresolved,
  // the last arg MUST be the shared state
  initialState,
)
